<template>
	<a class="skip-link" href="#main">{{ t('general.skip-to-content') }}</a>

	<site-header />

	<main id="main">
		<home-page />
	</main>

	<site-footer />
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import HomePage from '@/pages/HomePage.vue'

defineOptions({ name: 'App' })

const { t } = useI18n()
</script>
